import { render, staticRenderFns } from "./TipsPopup.vue?vue&type=template&id=20a2c984&scoped=true"
import script from "./TipsPopup.vue?vue&type=script&lang=js"
export * from "./TipsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2c984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20a2c984')) {
      api.createRecord('20a2c984', component.options)
    } else {
      api.reload('20a2c984', component.options)
    }
    module.hot.accept("./TipsPopup.vue?vue&type=template&id=20a2c984&scoped=true", function () {
      api.rerender('20a2c984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/TipsPopup.vue"
export default component.exports